/**
 * @file The LightApi is a property of the ViewportApi and must be used by all corresponding ViewportApis.
 *       It is used for all light related functionality.
 *
 * @module LightApiExpoDefault
 * @author Michael Oppitz
 */
let LightApi = function (_api, ___refs) {

  const LightApiInterface = require('../../../../interfaces/api/LightApiInterface');

  let _threeDManager = ___refs.threeDManager,
      _apiResponse = ___refs.apiResponse;

  /**
   * @lends module:LightApiExpoDefault~LightApi
   */
  class LightApi extends LightApiInterface {

    /**
     * ### ShapeDiver Viewer - Light API
     *
     * @constructs module:LightApiDefault~LightApi
     */
    constructor() {
      super();
    }

  }
  return new LightApi();
};

module.exports = LightApi;
